import { produce } from 'immer'

import { createSelector, createSlice } from '@reduxjs/toolkit'

import { createOrder } from './checkoutActions'

const initialState = {
  currentStep: 'CART',
  paymentError: null,
  paymentMethod: 'creditCard',
  status: 'DEFAULT',
  error: null,
  cart: [],
  transationId: null
  // cart: [...menu.slice(0, 2).map(o => ({ ...o, quantity: 1, uuid: uuidv4(), activeAddons: [], activeVariant: o.variants[0] }))]
}

export const checkoutSlice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    addToCart: (state, { payload }) => {
      const item = state.cart.find(o => o.uuid === payload.uuid)

      return item
        ? {
            ...state,
            cart: produce(state.cart, draftState => {
              draftState.find(o => o.id === item.id).quantity++
            })
          }
        : {
            ...state,
            cart: [...state.cart, { ...payload }]
          }
    },
    updateCartItem: (state, { payload }) => {
      const item = state.cart.find(o => o.uuid === payload.uuid)

      if (!item) {
        console.warn('updateCartItem - Item not found')
        return state
      }

      return {
        ...state,
        cart: produce(state.cart, draftState => {
          const index = draftState.findIndex(o => o.id === item.id)
          draftState[index] = payload
        })
      }
    },
    removeFromCart: (state, { payload }) => {
      return {
        ...state,
        cart: state.cart.filter(o => o.id.toString() !== payload.id.toString())
      }
    },
    setCurrentStep: (state, { payload }) => {
      return {
        ...state,
        currentStep: payload
      }
    },
    setPaymentMethod: (state, { payload }) => {
      return {
        ...state,
        paymentMethod: payload
      }
    },
    setPaymentError: (state, { payload }) => {
      return {
        ...state,
        paymentError: payload
      }
    },
    clearError: state => {
      return {
        ...state,
        status: 'DEFAULT',
        error: null
      }
    },
    setTransationId: (state, { payload }) => {
      return {
        ...state,
        transationId: payload
      }
    },
    reset: state => {
      return {
        ...initialState
      }
    }
  },
  extraReducers: builder => {
    builder.addCase(createOrder.pending, state => {
      state.status = 'LOADING'
    })
    builder.addCase(createOrder.fulfilled, (state, { payload }) => {
      state.status = 'SUCCESS'
      state.pickupOrderNumber = payload.pickupOrderNumber
    })
    builder.addCase(createOrder.rejected, (state, { payload }) => {
      state.status = 'ERROR'
      state.error = payload
    })
  }
})

const cartItems = state => state.cart

export const {
  setCurrentStep,
  addToCart,
  updateCartItem,
  removeFromCart,
  setPaymentMethod,
  setPaymentError,
  reset,
  clearError,
  setTransationId
} = checkoutSlice.actions

export const cartTotalSelector = createSelector(cartItems, cart =>
  cart.length > 0 ? cart.map(o => o.quantity * o.totalAmount).reduce((acc, current) => acc + current) : 0
)

export default checkoutSlice.reducer
